import { map } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import * as util from 'util';
import * as i0 from "@angular/core";
import * as i1 from "@azure/msal-angular";
import * as i2 from "@angular/router";
import * as i3 from "./config.service";
import * as i4 from "@angular/common/http";
export class AuthenticationService {
    constructor(msalService, broadcastService, router, config, http) {
        this.msalService = msalService;
        this.broadcastService = broadcastService;
        this.router = router;
        this.config = config;
        this.http = http;
    }
    signIn() {
        return this.msalService.loginPopup().pipe(catchError((err) => {
            // If an interactive request is already in progress, wait until
            // MSAL reports no interaction in progress then retry once.
            const isInteractionInProgress = err && (err.errorCode === 'interaction_in_progress' || err.errorMessage && err.errorMessage.indexOf('interaction_in_progress') >= 0);
            if (isInteractionInProgress) {
                return this.broadcastService.inProgress$.pipe(filter((status) => status === 'none'), take(1), switchMap(() => this.msalService.loginPopup()));
            }
            return throwError(err);
        }));
    }
    login() {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Authorization', 'Basic ' + this.getAuthorizationHeader());
        let userData = JSON.parse(sessionStorage.getItem('userInfo'));
        const body = util.format('grant_type=urn:ietf:params:oauth:grant-type:jwt-bearer&assertion=%s', encodeURIComponent(userData.idToken));
        return this.http.post(this.config.getConfig('ApiBaseURL').concat('/o365/oauth2/v2/token'), body, { headers: headers })
            .pipe(map((data) => {
            this.accessToken = data['access_token'];
            this.refreshToken = data['refresh_token'];
            sessionStorage.setItem('currentUser', JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken }));
            sessionStorage.setItem('fullTokenPayload', JSON.stringify(data));
            localStorage.setItem('currentUser', JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken }));
            localStorage.setItem('fullTokenPayload', JSON.stringify(data));
        }));
    }
    refreshAccessToken() {
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        let refreshToken = currentUser.refreshToken;
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Authorization', 'Basic ' + this.getAuthorizationHeader());
        const body = util.format('grant_type=refresh_token&refresh_token=%s', encodeURIComponent(refreshToken));
        return this.http.post(this.config.getConfig('ApiBaseURL').concat('/o365/oauth2/v2/token'), body, { headers: headers })
            .pipe(map((data) => {
            this.accessToken = data['access_token'];
            this.refreshToken = data['refresh_token'];
            sessionStorage.setItem('currentUser', JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken }));
            sessionStorage.setItem('fullTokenPayload', JSON.stringify(data));
            localStorage.setItem('currentUser', JSON.stringify({ accessToken: this.accessToken, refreshToken: this.refreshToken }));
            localStorage.setItem('fullTokenPayload', JSON.stringify(data));
            if (currentUser) {
                currentUser.accessToken = this.accessToken;
                currentUser.refreshToken = this.refreshToken;
                sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
                localStorage.setItem('currentUser', JSON.stringify(currentUser));
            }
        }));
    }
    getAuthorizationHeader() {
        return btoa(this.config.getConfig('ClientKey') + ':' + this.config.getConfig('ClientSecret'));
    }
    getAccessToken() {
        return JSON.parse(sessionStorage.getItem('currentUser')).accessToken;
    }
}
AuthenticationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.ɵɵinject(i1.MsalService), i0.ɵɵinject(i1.MsalBroadcastService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.ConfigService), i0.ɵɵinject(i4.HttpClient)); }, token: AuthenticationService, providedIn: "root" });
